// Password strength rules - mirrors backend utils/auth.py validate_password_strength
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_POLICY_MESSAGE =
  'Password must be at least 8 characters and include a letter, a number, and a special character.';

export function checkPasswordStrength(password) {
  const pwd = password ?? '';
  const checks = {
    length: pwd.length >= PASSWORD_MIN_LENGTH,
    letter: /[A-Za-z]/.test(pwd),
    number: /\d/.test(pwd),
    symbol: /[^A-Za-z0-9]/.test(pwd),
    noWhitespaceEdges: pwd.length > 0 && pwd === pwd.trim(),
  };
  const passedCount = [checks.length, checks.letter, checks.number, checks.symbol].filter(Boolean).length;
  const valid = checks.length && checks.letter && checks.number && checks.symbol && checks.noWhitespaceEdges;

  let label = 'Weak';
  let color = 'bg-destructive';
  if (passedCount === 4 && checks.noWhitespaceEdges) {
    label = 'Strong';
    color = 'bg-emerald-500';
  } else if (passedCount === 3) {
    label = 'Medium';
    color = 'bg-amber-500';
  } else if (passedCount === 2) {
    label = 'Fair';
    color = 'bg-orange-500';
  }

  return { checks, valid, label, color, passedCount };
}
